import Swiper from 'swiper/bundle';
import classToggle from '../helpers/class-toggle';
import { gsap } from 'gsap';

export default () => {
	const breakpoint = window.matchMedia( '(max-width:700px)' );
	let slider;

	const breakpointChecker = function() {
		if ( breakpoint.matches === false ) {
			if ( slider !== undefined ) slider.destroy( true, true );
			return;
		} else if ( breakpoint.matches === true) {
			return enableSwiper();
		}
	};

	const enableSwiper = function() {
		const sliderPrefix = 'product-main__';
		const sliderEl = document.querySelector(`.${sliderPrefix}slider`);
		const slideTransitionSpeed = 700;

		if (sliderEl) {
			let paginationEl = document.querySelector('.product-main__pagination .pagination');

			slider = new Swiper(sliderEl, {
				wrapperClass: `${sliderPrefix}slider-wrapper`,
				slideClass: `${sliderPrefix}slide`,
				slideActiveClass: `${sliderPrefix}slide--active`,
				slidesPerView: 'auto',
				speed: slideTransitionSpeed,
				loop: true,
				spaceBetween: 0,
				watchOverflow: true,
				pagination: {
					el: paginationEl,
					type: 'bullets',
					clickable: true,
					bulletClass: 'pagination__bullet',
					bulletActiveClass: 'pagination__bullet--active'
				},
			});
		}
	};

	breakpoint.addListener(breakpointChecker);
	breakpointChecker();



	const groups = document.querySelectorAll('.selector__group, .product-main__selector--singular');
	if (groups) {
		groups.forEach(function(group) {
			const swatches = group.querySelectorAll('.selector__radio');
			const btnBuy = group.querySelector('.js-buy-btn') || group.closest('.product-main__grid').querySelector('.js-buy-btn');
			const bisBlock = group.querySelector('.js-bis')
			const bisForm = group.querySelector('.js-bis-form')
			const doubleBlock = document.querySelector('.product-main__selector--double');
			
			swatches.forEach(function(swatch) {
				swatch.addEventListener('click', (e) => {
					e.preventDefault();
					
					bisBlock.classList.remove('bis--success');
					bisBlock.classList.remove('bis--error');

					if (!doubleBlock) {
						classToggle(swatches, swatch, 'selector__radio--active');
					} else {
						if (swatch.classList.contains('selector__radio--active')) {
							swatch.classList.remove('selector__radio--active');
						} else {
							classToggle(swatches, swatch, 'selector__radio--active');
						}
					}
					
					if (swatch.classList.contains('selector__radio--disabled')) {
						bisBlock.classList.add('bis--visible');
						btnBuy.classList.add('btn--disabled');
					} else {
						bisBlock.classList.remove('bis--visible');
						btnBuy.classList.remove('btn--disabled');
					}
					if (btnBuy) {
						btnBuy.dataset.id = swatch.dataset.id;
						bisForm.dataset.variantId = swatch.dataset.id;

						const price = swatch.dataset.price;
						const priceEl = btnBuy.querySelector('.js-buy-btn-price');
						if (price && priceEl) {
							priceEl.innerText = price;
						}
					}
				});
			});
		});
	}



	// back in stock
	const backInStockBlocks = document.querySelectorAll('.js-bis');
	backInStockBlocks.forEach(function(bis) {
		const form = bis.querySelector('.js-bis-form');
		const input = bis.querySelector('.js-bis-input');

		const success = bis.querySelector('.bis__text--thank');
		const error = bis.querySelector('.bis__text--error');

		if (form && input) {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				bis.classList.remove('bis--error');

				const email = input.value;
				const pid = +form.dataset.productId;
				const vid = +form.dataset.variantId;

				if (email && pid && vid) {
					BIS.create(email, vid, pid).then(function(resp) {
						if (resp.status == 'OK') {
							success.innerText = resp.message;
							bis.classList.add('bis--success');
						} else {
							error.innerText = resp.errors.base;
							bis.classList.add('bis--error');
						}
					});
				}
			});
		}
	});


	// expand description (old version)
	// const btnExpand = document.querySelector('.js-expand-desc');
	// const text = document.querySelector('.product-main__text');

	// if (btnExpand && text) {
	// 	btnExpand.addEventListener('click', (e) => {
	// 		e.preventDefault();
		
	// 		text.classList.toggle('product-main__text--expanded');
	// 	});
	// }


	// expand description

	const btnExpand = document.querySelector('.js-expand-desc');
	const text = document.querySelector('.product-main__text');

	if (btnExpand && text) {
		btnExpand.addEventListener('click', (e) => {
			e.preventDefault();
			let isActive = text.classList.toggle('product-main__text--expanded');
			gsap.to(text, {
				height: isActive ? 'auto' : '120px',
				duration: 0.5
			})
		});
	}
}